import { StyledFormControl } from "Components/Shared/FormStyles";
import { ColorInput } from "Components/Shared/Inputs/ColorInput";
import type { TextFieldProps } from "@mui/material";
import {
  type Control,
  Controller,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";

type Props<FormType extends FieldValues> = Omit<
  TextFieldProps,
  "value" | "onChange"
> & {
  name: FieldPath<FormType>;
  label?: string;
  control: Control<FormType, object>;
  disabled?: boolean;
  helperText?: string;
  placeholderColor?: string;
};

export const FormColorInput = <T extends object>(props: Props<T>) => {
  const { name, control, label, disabled, helperText, ...rest } = props;

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <StyledFormControl className={label ? "" : "no-label"}>
          <ColorInput
            value={value === null || value === undefined ? "" : value}
            onChange={onChange}
            name={name.toString()}
            label={label}
            helperText={error ? error.message : helperText}
            fieldError={error}
            disabled={disabled}
            {...rest}
          />
        </StyledFormControl>
      )}
    />
  );
};
